class YearIterator {
  constructor(items = [], selectedYear = 0) {
    this.updateYear(items, selectedYear);
  }
  current() {
    return this.items[this.index];
  }
  updateYear(items = [], selectedYear = 0) {
    const indexOfSelectedYear = items.indexOf(selectedYear);
    this.index = indexOfSelectedYear !== -1 ? indexOfSelectedYear : 0;
    this.items = items;
  }
  hasNext() {
    return this.index + 1 < this.items.length;
  }
  hasPrevious() {
    return typeof this.items[this.index - 1] !== 'undefined';
  }
  next() {
    if (this.hasNext()) {
      this.index += 1;
    }
    return this.items[this.index];
  }
  previous() {
    if (this.hasPrevious()) {
      this.index -= 1;
    }
    return this.items[this.index];
  }
}
module.exports = YearIterator;